<template>
  <CategoryTop :title="$t('shop.title')" :description="categoryPageDescription"
    :loader="categoriesRequestSent" :breadcrumbs-parent-routes="getBreadcrumbParentRoutes"
    :breadcrumbs-route-name="breadcrumbLastLabel" />
</template>

<script setup>
import CategoryTop from "../General/CategoryTop/index.vue";
import { useStore } from "vuex";
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { getCategoriesData } from "./products";

const { t, te } = useI18n();
const route = useRoute();
const store = useStore();

const currentLocale = computed(() => store.getters.getCurrentLocale);
const categoriesRequestSent = computed(
  () => store.getters.getCategoriesRequestSent,
);
const categoriesData = computed(() => getCategoriesData(store, route));

onMounted(() => {
  if (!store.getters.getCategories.length) {
    store.dispatch("loadCategories");
  }
});

const categoryPageDescription = computed(() => {
  const current = categoriesData.value.current;
  if (!current) {
    return "";
  }
  const descMap = current.description;
  if (!descMap) {
    return te("shop.categoryPageDescriptionFallback")
      ? t("shop.categoryPageDescriptionFallback")
      : "";
  }
  const fromApi = descMap[currentLocale.value] ?? "";
  if (String(fromApi).trim()) {
    return fromApi;
  }
  if (te("shop.categoryPageDescriptionFallback")) {
    return t("shop.categoryPageDescriptionFallback");
  }
  return "";
});

const breadcrumbLastLabel = computed(() => {
  const current = categoriesData.value.current;
  if (!current?.name) {
    return "";
  }
  return current.name[currentLocale.value] ?? "";
});

const getBreadcrumbParentRoutes = computed(() => {
  const routes = ["shop"];

  if (categoriesData.value.parent) {
    const p = categoriesData.value.parent;
    routes.push({
      name: "shopCategory",
      params: { id: p.id },
      query: { page: 1 },
      breadcrumbLabel: p.name?.[currentLocale.value] ?? "",
    });
  }

  return routes;
});
</script>

<style scoped lang="scss">
:deep(.description) {
  min-height: none;
}
</style>
